<template>
  <div>
    <div class="parents-QA-container">
      <div class="parents-QA-badge">{{ getSocialProof.badge }}</div>
      <div class="parents-solutions-title">{{ getSocialProof.title }}</div>
      <div class="parents-solutions-description">
        {{ getSocialProof.description }}
      </div>
      <div class="row">
        <div class="col-lg-4 col-12">
          <img :src="getSocialProof.image" class="pro-content-image" alt="" />
        </div>
        <div class="col-lg-8 col-12 pro-content-block">
          <div
            v-for="(content, i) in getSocialProof.content"
            :key="i"
            class="pro-content-par"
          >
            {{ content }}
          </div>
        </div>
      </div>
    </div>
    <div class="row parents-tutorial-timeline-bottom-banner">
      <div class="col-lg-8 col-12 text-left">
        <div class="parents-tutorial-timeline-title">First Week Free!</div>
        <div class="parents-tutorial-timeline-banner-desc">
          Enjoy a 7-day free trial! Get full access to our platform and live
          lessons.
        </div>
      </div>
      <div class="col-lg-4 col-12 pro-social-proof-button">
        <md-filled-tonal-button
          class="get-started-button"
          @click="$router.push('/book-demo')"
        >
          Book Your Free Trial Now
          <i class="mdi mdi-arrow-right"></i>
        </md-filled-tonal-button>
      </div>
    </div>
  </div>
</template>

<script>
import SwiperCore, { Autoplay, Pagination, Navigation } from "swiper/core";
import { mapGetters } from "vuex";

SwiperCore.use([Autoplay, Pagination, Navigation]);

export default {
  name: "parentsSolution",
  components: {},
  props: ["getSocialProof"],
  computed: {
    ...mapGetters(["getTestimonials", "getIndividualSolutions"]),
  },
  data() {
    return {
      panel: [0],
    };
  },
};
</script>

<style></style>
